import ComboCustomizeButton from  "./ComboCustomizeButton";
import ComboOrderButton from "./ComboOrderButton";
export default class SelectedComboItem extends React.Component {
    constructor(props) {
        super(props);
        this.sendDataForRemoval = this.sendDataForRemoval.bind(this);
        this.passCardOpensModalStatus = this.passCardOpensModalStatus.bind(this);
        this.getModalHeaderTextForComboToppingsComp = this.getModalHeaderTextForComboToppingsComp.bind(this);
        this.getModalHeaderIdForComboToppingsComp = this.getModalHeaderIdForComboToppingsComp.bind(this);
        this.getExtraToppingssDataForComboToppingsComp = this.getExtraToppingssDataForComboToppingsComp.bind(this);
        this.optionData = null;
        this.passModalImage = this.passModalImage.bind(this);
        this.passResetModalContent = this.passResetModalContent.bind(this)
        this.passCutomizedButtonClickStatus = this.passCutomizedButtonClickStatus.bind(this)
        this.getCalorieText = this.getCalorieText.bind(this)
        this.id = null;
        this.passPreselected = this.passPreselected.bind(this)
        this.onkeyRemovePress = this.onkeyRemovePress.bind(this)
    }

    componentDidMount() {
       /*  if(this.props.isEditMode){
            this.props.sendExtrasPrice(0)
        }else{
         
            this.props.price  != 0 ? this.props.sendExtrasPrice(this.props.price) : 0  
        }*/
        this.props.sendId(this.props.id) 
    }

    componentDidUpdate(){
        if(this.props.hideShowSelectedItemOnClose[0] == true){
               var selectedRemovalItem = $(`button#${this.props.updatedId[0]}.btn.remove-item`)
                selectedRemovalItem.click();
              this.props.hideShowSelectedItemOnClose[0] = false;
        }
    }
    passModalImage(modalImage){
        this.props.sendModalImage(modalImage);
    }
    passCardOpensModalStatus(CardOpensModalStatus){
        this.props.sendCardOpensModalState(CardOpensModalStatus)
    }
    passResetModalContent(modalResetStatus){
        this.props.sendModalContentResetStatus(modalResetStatus)
    }
    sendDataForRemoval(e){
       /* e.preventDefault();
          this.props.sendIdData(this.props.id);

          this.props.sendIdDataToResetAllModalControls(this.props.id);

          this.props.sendTitleDataToShowMenuOrderPanel(this.props.tiTle);

          this.props.sendExtrasPrice(-Math.abs(this.props.price));
          //this.props.sendExtrasPrice(-Math.abs(0));
          this.props.sendNotificationToResetCheckboxes(this.props.tiTle)

       $("#information_modal").attr("id","noModal"); */
    }

    passPreselected(preselected){
        this.props.sendPreselected(preselected)
    }

    getExtraToppingssDataForComboToppingsComp(extraToppingsData){
        this.props.passExtraToppingssDataForComboToppingsComp(extraToppingsData)
    }
    getModalHeaderIdForComboToppingsComp(modalHeaderId) {   
        this.props.passModalHeaderIdForComboToppingsComp(modalHeaderId)
    }

    getModalHeaderTextForComboToppingsComp(modalHeaderTitle){
        this.props.passModalHeaderTextForComboToppingsComp(modalHeaderTitle)
    }
    passCutomizedButtonClickStatus(CutomizedButtonClickStatus){
        this.props.sendCustomizedButtonClickedStatus(CutomizedButtonClickStatus)
    }
    /*
    getCalorieText()
    {
        return this.props.calories > 0 ? 
            this.props.calorieAdds + " " + this.props.calories :
            (this.props.calories < 0 ? this.props.calorieSubtracts + " " + (this.props.calories * -1) : this.props.calories)
    }
    */
    getCalorieText() {
        return this.props.calories > 0 ?
            this.props.calorieAdds + " " + (this.props.maxCalories ? this.props.calories + this.props.calorieSeparator + this.props.maxCalories : this.props.calories) :
            (this.props.calories < 0 ? this.props.calorieSubtracts + " " + (this.props.maxCalories ? (this.props.maxCalories * -1) + this.props.calorieSeparator + (this.props.calories * -1) : (this.props.calories * -1)) : "0");
    }
    onkeyRemovePress(e) {

        if (event.keyCode == 13) {
            $(document.activeElement).find("button").trigger("click");
        }

    }
    render() {
        return (
            <div id="chooseCategory">
            {/*<!-- ==== ihop combo category 1 ==== -->*/}
    
            {/*<!-- category body  -->*/}
            
                <div className="category-body position-relative">
                    <div className="cart-items">
                  <div className="row">
                      <div className="col-md-3 col-xs-3 col-sm-3 col-3 remove-right-pad">
{/*                          <img src={this.props.image} alt="cart item" className="mx-auto d-block food-img img-fluid" />                           
*/}                      </div>
                            <div className="col-md-6 col-xs-6 col-sm-6 col-6 remove-left-pad">
                                <div className="details" tabIndex="0" onKeyDown={this.onkeyRemovePress}>
                              <h5 id={this.props.id} className="dynamicTitle item-name">{this.props.tiTle}</h5>                              
                              {this.props.subTitle ? <p id={this.props.subtitleId} className="item-description">{this.props.subTitle} </p>:null}
                              {this.props.price > 0 ?<p className="item-cal addcombo-price">+${(this.props.price).toFixed(2)}</p> : null}
                                    {this.props.calories ? <p className="item-cal">{this.getCalorieText()}&nbsp;<abbr aria-label={this.props.caloriesText}>{this.props.calorieAbbr}</abbr></p> : null}
                                    <button id={this.props.id} tabIndex="0" type="button" onClick={this.sendDataForRemoval} className="btn remove-item"><i className="bi bi-x-circle"></i> {this.props.removeButtonText}</button> </div>
                      </div>
                      {this.props.moreOptionsAvailable.length > 0 &&
                   
                      <div className="col-md-3 col-xs-3 col-sm-3 col-3">
                           <ComboCustomizeButton 
                             getExtraToppingssData = {this.props.moreOptionsAvailable}
                             image = {this.props.image}
                             modalTitle = {this.props.tiTle}
                             modalId = {this.props.id}
                             sendOptionsData = {this.getExtraToppingssDataForComboToppingsComp}
                             sendModalHeaderText = {this.getModalHeaderTextForComboToppingsComp}
                             sendModalHeaderId={this.getModalHeaderIdForComboToppingsComp }
                             sendModalImage = {this.passModalImage}
                             sendCardOpensModalStatus={this.passCardOpensModalStatus}
                             resetModalContent = {this.passResetModalContent}
                             disableModalOnLoad = {this.props.disableModalOnLoad}
                             IsCustomizedItem = {this.passCutomizedButtonClickStatus}
                             CustomizeText={this.props.customizeButtonText}
                             sendPreselected = {this.passPreselected}
                             cardSubTitle = {this.props.subTitle}
                             cardSubId = {this.props.subtitleId}
                             isEditMode = {this.props.isEditMode}
                           />
                      </div>
                      }
                  </div>                   
              </div>     
           
            </div>
            
            
            {/*<!-- category body  -->*/}
          
         {/*<!-- ==== ihop combo category 1 ==== -->*/}
        </div>
        );
    }
}
       












